module.exports = __webpack_public_path__ + "media/images/keyVisual_mobile_th-075760bd06ad6dab812fc6bcc948a810.jpg";